<script setup>
import Header from "@/components/Header.vue";
import HeroSection from "@/components/HeroSection.vue";
</script>

<template>
  <div>
    <Header />
    <HeroSection />
  </div>
</template>
